import { jsx as _jsx } from "react/jsx-runtime";
import { Button, styled } from '@mui/material';
import { PentairIconClose, PentairIconConfirm, PentairIconCreate, PentairIconDelete, PentairIconList, PentairIconNext, PentairIconPrevious, PentairIconReset, PentairIconSpinner, } from './pentair-icon';
export const PentairButton = ({ loading, children, ...props }) => {
    const disabled = props.disabled ?? loading;
    if (props.size === 'small') {
        props.color = props.color ?? 'secondary';
    }
    if (props.startIcon) {
        return (_jsx(Button, { ...props, disabled: disabled, startIcon: loading ? _jsx(PentairIconSpinner, {}) : props.startIcon, children: children }));
    }
    if (props.endIcon) {
        return (_jsx(Button, { ...props, disabled: disabled, endIcon: loading ? _jsx(PentairIconSpinner, {}) : props.endIcon, children: children }));
    }
    return (_jsx(Button, { ...props, disabled: disabled, children: children }));
};
export const ButtonCreate = styled(PentairButton)({});
ButtonCreate.defaultProps = { startIcon: _jsx(PentairIconCreate, {}) };
export const ButtonDelete = styled(PentairButton)({});
ButtonDelete.defaultProps = { startIcon: _jsx(PentairIconDelete, {}), color: 'error' };
export const ButtonSubmit = styled(PentairButton)({});
ButtonSubmit.defaultProps = { startIcon: _jsx(PentairIconConfirm, {}) };
export const ButtonNext = styled(PentairButton)({});
ButtonNext.defaultProps = { endIcon: _jsx(PentairIconNext, {}) };
export const ButtonPrevious = styled(PentairButton)({});
ButtonPrevious.defaultProps = { startIcon: _jsx(PentairIconPrevious, {}), color: 'inherit', variant: 'text' };
export const ButtonReset = styled(PentairButton)({});
ButtonReset.defaultProps = { startIcon: _jsx(PentairIconReset, {}), color: 'inherit', variant: 'text' };
export const ButtonCancel = styled(PentairButton)({});
ButtonCancel.defaultProps = { color: 'info', startIcon: _jsx(PentairIconClose, {}) };
export const ButtonShowAll = styled(PentairButton)({});
ButtonShowAll.defaultProps = { startIcon: _jsx(PentairIconList, {}) };
